<ng-container *ngIf="isDxsales">  
<header class="header"></header>
<div class="container-gray isBackgoround">
  <main>
    <div class="v-application v-application--is-ltr theme--light main">
  <form
    id="change-password-form"
    (submit)="submitChangePassword()"
    class="v-application--is-ltr"
    style="
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    "
  >
  <h1 class="mb-10 h3" style="justify-content: center;display: flex;">パスワードの変更</h1>
    <div
      class="mb-10 v-card v-sheet theme--light elevation-0"
      style="
        width: 410px;
        background-color: var(--color-100-bold);
        border-color: var(--color-100-bold);
      "
    >
        <div class="v-card__title text-caption">
          <div style="padding: 10px">
            <p
              class="text-subtitle-1 d-flex align-center mb-2"
              style="height: 28px; display: flex; justify-content: center"
            >
              <!-- <i
                id="icon-question"
                aria-hidden="true"
                class="v-icon notranslate v-icon--left mdi mdi-help-circle theme--right"
              ></i> -->
              <span class="v-text-font-14">認証情報は以下のシステムで共通となります。</span>
            </p>
            <p class="bold-14">
              <img [src]="checkmarkImageUrl" style="margin: 10px;" alt="登録支援システム" height="16">登録支援システム<br>
              <img [src]="checkmarkImageUrl" style="margin: 10px;" alt="処方元情報連携システム" height="16">処方元情報連携システム<br>
              <img [src]="checkmarkImageUrl" style="margin: 10px;" alt="症例情報連携システム" height="16">症例情報連携システム<br>
            </p>
          </div>
        </div>
      </div>
    <!-- Do not remove this.  This protects against CSRF vulnerabilities -->
    <!-- <input type="hidden" id="_csrf" name="_csrf" value="{{ csrf_token }}" />
            <input type="hidden" id="ticket" name="ticket" value="{{ ticket }}" />
            <input type="hidden" id="email" name="email" value="{{ email }}" /> -->

    <div class="common_input" style="display: flex; align-items: center">
      <label class="bold" style="height: 29px; margin-right: 12px;">新しいパスワード</label>
      <app-required-label></app-required-label>
    </div>
    <div
      class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
      style="display: flex; justify-content: center; width: 550px; max-width: 90vw"
    >
      <div class="v-input__control">
        <app-collabo-portal-password-input
          [(ngModel)]="password"
          name="password"
          placeholder="パスワード"
          class="text-black-38"
        ></app-collabo-portal-password-input>
        <div _ngcontent-bwu-c24="" class="v-text-field__details">
          <div
            id="errorMessagePassword"
            _ngcontent-bwu-c24=""
            class="hidden v-messages theme--light error--text"
            *ngIf="errorMessages.password"
          >
            <div
              _ngcontent-bwu-c24=""
              class="v-messages__wrapper ng-star-inserted"
            >
              {{ errorMessages.password }}
            </div>
            <!---->
          </div>
          <div *ngIf="!errorMessages.password">
            <p class="v-text-caption">
              半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="common_input" style="display: flex; align-items: center">
      <label class="bold" style="height: 29px; margin-right: 12px;">新しいパスワード（確認用）</label>
      <app-required-label></app-required-label>
    </div>
    <div
      class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
      style="display: flex; justify-content: center; width: 550px; max-width: 90vw"
    >
      <div class="v-input__control">
        <app-collabo-portal-password-input
          [(ngModel)]="confirmationPassword"
          name="confirm"
          placeholder="パスワード（再入力）"
        ></app-collabo-portal-password-input>
        <div _ngcontent-bwu-c24="" class="v-text-field__details">
          <div
            id="errorMessageConfirmPassword"
            _ngcontent-bwu-c24=""
            class="hidden v-messages theme--light error--text"
            *ngIf="errorMessages.confirmPassword"
          >
            <div
              _ngcontent-bwu-c24=""
              class="v-messages__wrapper ng-star-inserted"
            >
              {{ errorMessages.confirmPassword }}
            </div>
            <!---->
          </div>
          <div *ngIf="!errorMessages.confirmPassword">
            <!-- <p class="v-text-caption">
              パスワードを確認するために再入力してください
            </p> -->
          </div>
        </div>
      </div>
    </div>

    <div _ngcontent-ohw-c49="" class="text-center mb-5" style="width: 550px; max-width: 90vw">
      <button
        _ngcontent-ohw-c49=""
        type="button"
        medium=""
        style="width: 100%;"
        class="full-width primary-button v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
        (click)="submitChangePassword()"
      >
        <span _ngcontent-ohw-c49="" class="text-button-medium v-btn__content">
          パスワードを再設定する
        </span>
      </button>
    </div>
  </form>
  </div>
  </main>
  <!-- <footer class="footer">Copyright © DOCTORS Inc. All Rights Reserved.</footer> -->
</div>

<!-- <script src="https://cdn.auth0.com/js/change-password-1.5.min.js"></script> -->
</ng-container>
<ng-container *ngIf="!isDxsales">
  <header class="header">
    <img [src]="logoImageUrl" width="233px"/>
  </header>
  <div class="container">
    <h1 style="justify-content: center;display: flex;">パスワードの変更</h1>
  
    <form
      id="change-password-form"
      (submit)="submitChangePassword()"
      class="v-application--is-ltr"
    >
      <!-- Do not remove this.  This protects against CSRF vulnerabilities -->
      <!-- <input type="hidden" id="_csrf" name="_csrf" value="{{ csrf_token }}" />
              <input type="hidden" id="ticket" name="ticket" value="{{ ticket }}" />
              <input type="hidden" id="email" name="email" value="{{ email }}" /> -->
  
      <p class="v-text bold">新しいパスワード</p>
      <div
        class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
      >
        <div class="v-input__control">
          <app-collabo-portal-password-input
            [(ngModel)]="password"
            name="password"
            placeholder="パスワード"
            class="text-black-38"
          ></app-collabo-portal-password-input>
          <div _ngcontent-bwu-c24="" class="v-text-field__details">
            <div
              id="errorMessagePassword"
              _ngcontent-bwu-c24=""
              class="hidden v-messages theme--light error--text"
              *ngIf="errorMessages.password"
            >
              <div
                _ngcontent-bwu-c24=""
                class="v-messages__wrapper ng-star-inserted"
              >
                {{ errorMessages.password }}
              </div>
              <!---->
            </div>
            <div *ngIf="!errorMessages.password">
              <p class="v-text-caption">
                半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください
              </p>
            </div>
          </div>
        </div>
      </div>
  
      <p class="v-text bold">新しいパスワード（確認用）</p>
      <div
        class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
      >
        <div class="v-input__control">
          <app-collabo-portal-password-input
            [(ngModel)]="confirmationPassword"
            name="confirm"
            placeholder="パスワード（再入力）"
          ></app-collabo-portal-password-input>
          <div _ngcontent-bwu-c24="" class="v-text-field__details">
            <div
              id="errorMessageConfirmPassword"
              _ngcontent-bwu-c24=""
              class="hidden v-messages theme--light error--text"
              *ngIf="errorMessages.confirmPassword"
            >
              <div
                _ngcontent-bwu-c24=""
                class="v-messages__wrapper ng-star-inserted"
              >
                {{ errorMessages.confirmPassword }}
              </div>
              <!---->
            </div>
            <div *ngIf="!errorMessages.confirmPassword">
              <!-- <p class="v-text-caption">
                パスワードを確認するために再入力してください
              </p> -->
            </div>
          </div>
        </div>
      </div>
  
      <div _ngcontent-ohw-c49="" class="text-center mb-5">
        <button
          _ngcontent-ohw-c49=""
          type="button"
          medium=""
          class="full-width primary-button v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
          (click)="submitChangePassword()"
        >
          <span _ngcontent-ohw-c49="" class="text-button-medium v-btn__content">
            パスワードを再設定する
          </span>
        </button>
      </div>
    </form>
    <!-- <footer class="footer">Copyright © DOCTORS Inc. All Rights Reserved.</footer> -->
  </div>
  
  <!-- <script src="https://cdn.auth0.com/js/change-password-1.5.min.js"></script> -->
</ng-container>